import { render, staticRenderFns } from "./SupplementReview.vue?vue&type=template&id=378c9062&scoped=true&"
import script from "./SupplementReview.vue?vue&type=script&lang=js&"
export * from "./SupplementReview.vue?vue&type=script&lang=js&"
import style0 from "./SupplementReview.vue?vue&type=style&index=0&id=378c9062&prod&scoped=true&lang=css&"
import style1 from "./SupplementReview.vue?vue&type=style&index=1&id=378c9062&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378c9062",
  null
  
)

export default component.exports